import classNames from 'classnames/bind';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

const S05 = () => {
  return (
    <section className={cx('container')}>
      <div className={cx('header')}>
        <h3 className={cx('title')}>SIMPLE</h3>
      </div>
      <article className={cx('content')}>
        {/* <p className={cx('subtitle')}>세 번째 약속! 언제 어디서나 간편한 케어</p> */}
        <h4 className={cx('title')}>SIMPLE</h4>
        <p className={cx('desc')}>
          LEVRAI cares for every member of the family —
          <br />
          from little ones to moms and dads.
          <br />
          Because skincare should be something everyone can enjoy, together.
        </p>
        <ul className={cx('simpleList')}>
          <li>
            <h5>SIMPLE #1</h5>
            <span />
            <p>Easy formats kids can use all on their own</p>
          </li>
          <li>
            <h5>SIMPLE #2</h5>
            <span />
            <p>Travel-friendly, gift-ready designs for any moment</p>
          </li>
        </ul>
        <p className={cx('note')}>A premium lifestyle for the whole family — AVEC LEVRAI</p>
      </article>
    </section>
  );
};

export default S05;
